var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "lpu-schedule-days",
      class: { "lpu-schedule-days--v5": _setup.ff_lpu_branding_page_v5 },
    },
    [
      _c("div", {
        staticClass: "lpu-schedule-days__fog lpu-schedule-days__fog--left",
        class: { "lpu-schedule-days__fog--visible": !_setup.isAtStart },
      }),
      _vm._v(" "),
      _c(_setup.CoreSwiper, {
        ref: "swiperRef",
        attrs: {
          "free-mode": "",
          "slides-per-view": "auto",
          "has-pagination": false,
          "has-navigation": !_setup.isMobile,
          "space-between": 8,
          "placeholder-min-height": 66,
        },
        scopedSlots: _vm._u([
          {
            key: "slides",
            fn: function ({ slideAttrs }) {
              return _vm._l(_vm.items, function (item) {
                return _c(
                  "div",
                  _vm._b(
                    {
                      key: item.date,
                      staticClass: "lpu-schedule-days__slide",
                      on: {
                        click: function ($event) {
                          return _setup.onDayClick(item)
                        },
                      },
                    },
                    "div",
                    slideAttrs,
                    false
                  ),
                  [
                    _c(_setup.SelectableTab, {
                      staticClass: "lpu-schedule-days__tab",
                      attrs: {
                        small: "",
                        title: item.title,
                        subtitle: item.subtitle,
                        label: item.label,
                        active: item.date === _vm.activeDate,
                        disabled: item.disabled,
                      },
                      scopedSlots: _vm._u(
                        [
                          _setup.isWeekend(item.subtitle) &&
                          item.date !== _vm.activeDate &&
                          !item.disabled
                            ? {
                                key: "subtitle",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "text-error--text" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(item.subtitle) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "lpu-schedule-days__fog lpu-schedule-days__fog--right",
        class: { "lpu-schedule-days__fog--visible": !_setup.isAtEnd },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }